export default __webpack_public_path__ + "static/media/SA-logo.93822d2b.png";